import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../../user-redux/selector";
import {
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { myCandidatesSelector } from "../../redux/selector";

const Step1 = ({ emailDataHandler, handleNext }) => {
  const dispatch = useDispatch();
  const {
    candidateDetails,
    candidateJobs,
    candidateJobsCount,
    jobDetails,
    keywords,
    searchCompanyName,
    searchLocation,
  } = useSelector(myCandidatesSelector);
  const { user } = useSelector(userSelector);

  const [formData, setFormData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const candidateNameRef = useRef(null);
  const toEmailRef = useRef(null);
  const subjectRef = useRef(null);


  useEffect(() => {
    if (candidateDetails && jobDetails) {
      setFormData({
        candidateName: candidateDetails?.candidate_name,
        candidateid: candidateDetails?.candidate_id,
        toEmail: candidateDetails?.email,
        linkedin: candidateDetails?.linkedin_url,
        contachNum: candidateDetails?.phone || candidateDetails?.contact_no,
        userid: user?.id,
        jobid: jobDetails?.id,
        ccmail: [],
        subject: `${jobDetails?.jobtitle} - ${jobDetails?.company_name}`,
        description: jobDetails?.job_description,
        leadid: "",
        duration: "",
        emailBody: "",
        fromEmail: jobDetails?.email_id,
        sgfromEmail: user?.username,
        companyid: user?.companyid
      });
      emailDataHandler({
        candidateName: candidateDetails?.candidate_name,
        candidateid: candidateDetails?.candidate_id,
        toEmail: candidateDetails?.email,
        linkedin: candidateDetails?.linkedin_url,
        contachNum: candidateDetails?.phone || candidateDetails?.contact_no,
        userid: user?.id,
        jobid: jobDetails?.id,
        ccmail: [],
        subject: `${jobDetails?.jobtitle} - ${jobDetails?.company_name}`,
        description: jobDetails?.job_description,
        leadid: "",
        duration: "",
        emailBody: "",
        fromEmail: jobDetails?.email_id,
        sgfromEmail: user?.username,
        companyid: user?.companyid
      });
    }
  }, [candidateDetails, jobDetails]);

  const [errors, setErrors] = useState({
    candidateName: "",
    toEmail: "",
    cc: "",
    subject: "",
    description: "",
  });

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    if (!formData.candidateName) {
      newErrors.candidateName = "Candidate Name is required";
      isValid = false;
      // Focus on the first field with an error
      candidateNameRef.current.focus();
    } else {
      newErrors.candidateName = "";
    }

    if (!formData.toEmail) {
      newErrors.toEmail = "To Email is required";
      isValid = false;
      // Focus on the first field with an error
      toEmailRef.current.focus();
    } else {
      newErrors.toEmail = "";
    }

    // ... (other validations and focus logic)

    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (field, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value,
    }));
    emailDataHandler((prevFormData) => ({
      ...prevFormData,
      [field]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: "",
    }));
  };

  return (
    <Grid container spacing={1} sx={{ paddingX: 4, paddingBottom: 6 }}>
      {/* <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Send Job To Candidate
        </Typography>
      </Grid> */}
      <Grid item xs={6}>
        <FormControl fullWidth sx={{ m: 1 }} variant="standard">
          <InputLabel htmlFor="candidateName">Candidate Name</InputLabel>
          <Input
            id="candidateName"
            value={formData.candidateName}
            onChange={(e) => handleChange("candidateName", e.target.value)}
            error={!!errors.candidateName}
            // startAdornment={<InputAdornment position="start">C</InputAdornment>}
            inputRef={candidateNameRef}
          />
          {errors.candidateName && (
            <Typography variant="caption" color="error">
              {errors.candidateName}
            </Typography>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl fullWidth sx={{ m: 1 }} variant="standard">
          <InputLabel htmlFor="toEmail">To</InputLabel>
          <Input
            id="toEmail"
            value={formData.toEmail}
            onChange={(e) => handleChange("toEmail", e.target.value)}
            error={!!errors.toEmail}
            // startAdornment={<InputAdornment position="start">T</InputAdornment>}
            inputRef={toEmailRef}
          />
          {errors.toEmail && (
            <Typography variant="caption" color="error">
              {errors.toEmail}
            </Typography>
          )}
        </FormControl>
      </Grid>
      {/* Uncomment the following lines to enable CC field */}
      {/* <Grid item xs={6}>
        <FormControl fullWidth sx={{ m: 1 }} variant="standard">
          <InputLabel htmlFor="ccmail">CC</InputLabel>
          <Input
            id="ccmail"
            value={formData.ccmail}
            onChange={(e) => handleChange("ccmail", e.target.value)}
            error={!!errors.ccmail}
            // startAdornment={<InputAdornment position="start">CC</InputAdornment>}
            // placeholder='CC'
          />
        </FormControl>
      </Grid> */}
      <Grid item xs={12}>
        {/* <FormControl fullWidth sx={{ m: 1 }} variant="standard">
          <InputLabel htmlFor="subject">Subject</InputLabel>
          <Input
            id="subject"
            value={formData.subject}
            onChange={(e) => handleChange('subject', e.target.value)}
            error={!!errors.subject}
            // startAdornment={<InputAdornment position="start">S</InputAdornment>}
          />
        </FormControl> */}
        <FormControl fullWidth sx={{ m: 1 }} variant="standard">
          <InputLabel htmlFor="subject">Subject</InputLabel>
          <Input
            id="subject"
            value={formData.subject}
            onChange={(e) => handleChange("subject", e.target.value)}
            error={!!errors.subject}
            // startAdornment={<InputAdornment position="start">S</InputAdornment>}
            inputRef={subjectRef}
          />
          {errors.subject && (
            <Typography variant="caption" color="error">
              {errors.subject}
            </Typography>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <div style={{ height: "250px" }}>
          <ReactQuill
            value={formData.description}
            onChange={(value) => handleChange("description", value)}
            modules={{ toolbar: [["bold", "italic", "underline", "link"]] }}
            formats={["bold", "italic", "underline", "link"]}
            placeholder="Enter your message..."
            style={{ height: "300px" }}
          />
        </div>
        {errors.description && (
          <Typography variant="caption" color="error">
            {errors.description}
          </Typography>
        )}
      </Grid>
      {/* <Grid item xs={12} textAlign="end">
        <Button
          type="submit"
          variant="contained"
          size="small"
          color="primary"
          sx={{ width: '100px', mt: 2 }}
          onClick={(e) => handleSubmit(e)}
        >
          {isSubmitting ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
        </Button>
      </Grid> */}
    </Grid>
  );
};

export default Step1;
